import * as React from "react";
import { Button as AButton, Col, Row, Spin } from "antd";
import { ButtonProps } from "antd/es/button";
import { LoadingOutlined } from "@ant-design/icons";
import { TrashIcon } from "../icons/trash-icon";
import { FinanceIcon } from "../icons/finance-icon";

type type =
  | "primary"
  | "secondary"
  | "text"
  | "action-1"
  | "action-2"
  | "action-3"
  | "delete"
  | "delete-ghost"
  | "setup-bank"
  | "warning";

type Props = Omit<ButtonProps, "type"> & {
  type?: type;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
};

const Button = ({ type, leftIcon, rightIcon, children, loading, ...props }: Props) => {
  const btnProps: ButtonProps = { ...props };

  switch (type) {
    case "secondary":
      btnProps.type = "ghost";
      break;

    case "text":
      btnProps.type = "text";
      break;

    case "action-1":
    case "action-2":
    case "action-3":
      btnProps.type = "primary";
      btnProps.className = `cr-${type}`;
      break;

    case "delete":
      btnProps.type = "text";
      btnProps.className = `cr-${type}`;
      break;

    case "delete-ghost":
      btnProps.type = "ghost";
      btnProps.className = `cr-${type}`;
      break;

    case "warning":
      btnProps.type = "text";
      btnProps.className = `cr-warning-notice`;
      break;

    case "setup-bank":
      btnProps.type = "text";
      btnProps.className = `cr-${type}`;
      break;

    default:
      btnProps.type = "primary";
  }

  return (
    <AButton {...btnProps} style={btnProps.style}>
      <Row justify='center' align='middle' gutter={5} wrap={false}>
        {loading && (
          <Col style={{ display: "flex", alignItems: "center" }}>
            <Spin
              size={btnProps.size == "middle" ? "default" : btnProps.size}
              indicator={<LoadingOutlined spin />}
            />
          </Col>
        )}
        {!loading && (
          <>
            {leftIcon && <Col style={{ display: "flex", alignItems: "center" }}>{leftIcon}</Col>}
            {type === "delete" && (
              <div style={{ marginRight: children ? 10 : 0 }}>
                <TrashIcon />
              </div>
            )}
            {type === "setup-bank" && (
              <div style={{ marginRight: children ? 10 : 0 }}>
                <FinanceIcon />
              </div>
            )}

            {children && <Col>{children}</Col>}
            {rightIcon && <Col style={{ display: "flex", alignItems: "center" }}>{rightIcon}</Col>}
          </>
        )}
      </Row>
    </AButton>
  );
};

export default Button;
